import { Link } from "react-router-dom"
import AdminDashboardStatCard from "@/components/admin/AdminDashboardStatCard"
import Icon from "@/components/common/Icon"
import Loading from "@/components/common/Loading"
import StatusBadge from "@/components/common/StatusBadge"
import { useAdminDashboard } from "@/domain/admin/hooks/AdminDashboardHook"

export default function AdminDashboardPage() {
  const { useAdminDashboardState } = useAdminDashboard()
  const { summary, isLoaded, errorMessage } = useAdminDashboardState()

  if (!isLoaded) return <Loading label="대시보드를 불러오는 중" />

  if (errorMessage || !summary) {
    return (
      <div className="app-page-admin">
        <p
          role="alert"
          className="app-alert app-alert-error"
        >
          {errorMessage || "대시보드를 불러오지 못했습니다."}
        </p>
      </div>
    )
  }

  return (
    <div className="app-page-admin">
      <section className="app-page-head flex flex-col justify-between gap-4 md:flex-row md:items-end">
        <div>
          <p className="app-txt-eyebrow text-app-primary-600">DASHBOARD</p>
          <h2 className="app-txt-h1 mt-2">
            안녕하세요, {summary.managerName} 관리자님
          </h2>
          <p className="app-txt-body2 mt-2 text-app-text-200">
            오늘 대회 운영 현황과 처리할 업무를 확인하세요.
          </p>
        </div>
        <Link
          to="/admin/tournaments/new"
          className="focus-ring app-btn app-btn-primary shrink-0"
        >
          <Icon
            name="trophy"
            size={18}
          />
          새 대회 등록
        </Link>
      </section>

      <section>
        <h3 className="app-txt-h3">통계</h3>

        <div className="app-grid-hairline mt-4 sm:grid-cols-2 xl:grid-cols-4">
          {summary.stats.map((stat) => (
            <AdminDashboardStatCard
              key={stat.key}
              stat={stat}
            />
          ))}
        </div>
      </section>

      <section className="mt-5">
        <article className="app-surface overflow-hidden">
          <div className="flex items-center justify-between gap-3 border-b border-app-secondary-300 px-5 py-5 sm:px-6">
            <div>
              <h3 className="app-txt-h3">최근 신청 선수</h3>
              <p className="app-txt-caption mt-1 font-medium text-app-text-200">
                새로 접수된 참가 신청 내역입니다.
              </p>
            </div>
            <Link
              to="/admin/entries"
              className="focus-ring app-txt-button inline-flex shrink-0 items-center gap-1 text-app-primary-600 transition hover:text-app-primary-700"
            >
              전체보기
              <Icon
                name="arrow"
                size={16}
              />
            </Link>
          </div>

          <div className="overflow-x-auto">
            <table className="app-table app-table-hover min-w-[680px]">
              <caption className="sr-only">최근 접수된 참가 신청 목록</caption>
              <thead>
                <tr>
                  <th scope="col">신청번호</th>
                  <th scope="col">선수 / 체육관</th>
                  <th scope="col">신청 부문</th>
                  <th scope="col">신청일</th>
                  <th
                    scope="col"
                    className="text-right"
                  >
                    신청 상태
                  </th>
                </tr>
              </thead>
              <tbody>
                {summary.recentEntries.map((entry) => (
                  <tr key={entry.entryNo}>
                    <td className="app-txt-caption font-mono whitespace-nowrap text-app-text-200">
                      {entry.entryNo}
                    </td>
                    <td>
                      <p className="font-bold">{entry.playerName}</p>
                      <p className="app-txt-caption mt-0.5 font-medium text-app-text-200">
                        {entry.gymName}
                      </p>
                    </td>
                    <td className="whitespace-nowrap text-app-text-300">
                      {entry.category}
                    </td>
                    <td className="whitespace-nowrap text-app-text-200">
                      {entry.appliedAtText}
                    </td>
                    <td className="text-right">
                      <StatusBadge label={entry.statusLabel} />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </article>
      </section>
    </div>
  )
}
